
<template>
    <v-container fluid>
        <v-row dense>
            <v-col v-for="item in items" :key="item.to" cols="12" sm="6" md="4">
                <StatCard :tone="item.tone" :icon="item.icon" :title="item.title" :description="item.description"
                    :image="item.src" :to="item.to" :action-label="item.actionLabel" :disabled="soloUsuario" tinted>
                </StatCard>
            </v-col>
        </v-row>
        <v-card class="elevation-4 mt-2">
            <div class="px-4 pt-2 pb-4">
                <PageHeader title="Estadísticas" icon="fas fa-chart-bar"
                    help="Dinero y piezas del periodo elegido. Sin fechas, el dinero muestra los últimos 366 días. Inventario y cuentas por cobrar/pagar son al día de hoy. Sin acceso a todas las sucursales, solo ves los datos de la tuya.">
                    <template v-slot:actions>
                        <div class="dashboard-tools">
                            <StatusChip v-if="!soloUsuario && !verTodas" label="Solo tu sucursal" tone="info"
                                icon="fas fa-store"></StatusChip>
                            <div v-if="showSucursalFilter" class="form-compact dashboard-filter">
                                <v-select v-model="filters.sucursalId" :items="sucursales" item-text="nombre"
                                    item-value="id" label="Sucursal" prepend-inner-icon="fas fa-store" clearable filled
                                    outlined hide-details dense></v-select>
                            </div>
                            <div v-if="productos.length" class="form-compact dashboard-filter">
                                <v-autocomplete v-model="filters.productoId" :items="productos" item-text="nombre"
                                    item-value="id" label="Producto" prepend-inner-icon="fas fa-box" clearable filled
                                    outlined hide-details dense></v-autocomplete>
                            </div>
                            <div class="form-compact dashboard-range">
                                <DateRangeField :start.sync="range.start" :end.sync="range.end" title="Fecha"
                                    :extra-presets="['week']">
                                </DateRangeField>
                            </div>
                        </div>
                    </template>
                </PageHeader>
                <template v-if="!soloUsuario">
                    <v-tabs v-model="tab" show-arrows class="mt-2">
                        <v-tab v-for="t in tabs" :key="t.key">{{ t.label }}</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="tab" class="pt-2">
                        <v-tab-item v-for="t in tabs" :key="t.key">
                            <template v-if="t.key === 'resumen'">
                                <GraficaDinero :start="range.start" :end="range.end" :all-branches="verTodas"
                                    v-bind="filterProps"></GraficaDinero>
                            </template>
                            <template v-else-if="t.key === 'ventas'">
                                <GraficaVenta :start="range.start" :end="range.end" :all-branches="verTodas"
                                    v-bind="filterProps"></GraficaVenta>
                                <!-- El ranking entre productos no tiene sentido con un producto elegido: se oculta. -->
                                <GraficaProductos v-if="verTopProductos && !filters.productoId" :start="range.start" :end="range.end"
                                    v-bind="filterProps" class="mt-1"></GraficaProductos>
                            </template>
                            <template v-else-if="t.key === 'cuentas'">
                                <GraficaCompras :start="range.start" :end="range.end" v-bind="filterProps">
                                </GraficaCompras>
                                <v-row dense>
                                    <v-col cols="12" md="6">
                                        <CuentasPendientes kind="cobrar" title="Cuentas por cobrar"
                                            icon="fas fa-hand-holding-dollar" tone="warning" v-bind="filterProps">
                                        </CuentasPendientes>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <CuentasPendientes kind="pagar" title="Cuentas por pagar"
                                            icon="fas fa-file-invoice-dollar" tone="danger" v-bind="filterProps">
                                        </CuentasPendientes>
                                    </v-col>
                                </v-row>
                            </template>
                            <InventarioResumen v-else v-bind="filterProps"></InventarioResumen>
                        </v-tab-item>
                    </v-tabs-items>
                </template>
            </div>
        </v-card>
    </v-container>
</template>
<script>
import DateRangeField from '@/components/shared/DateRangeField.vue';
import PageHeader from '@/components/shared/PageHeader.vue';
import StatCard from '@/components/shared/StatCard.vue';
import StatusChip from '@/components/shared/StatusChip.vue';
import CuentasPendientes from '../graficas/CuentasPendientes.vue';
import GraficaCompras from '../graficas/GraficaCompras.vue';
import GraficaDinero from '../graficas/GraficaDinero.vue';
import GraficaProductos from '../graficas/GraficaProductos.vue';
import GraficaVenta from '../graficas/GraficaVenta.vue';
import InventarioResumen from '../graficas/InventarioResumen.vue';
import ProductoDataService from '@/service/producto/ProductoDataService';
import SucursalDataService from '@/service/catalogo/sucursal/sucursalDataService';
import { can, CAP } from '@/service/permiso/capacidades';
import { presetRange } from '@/utils/dateRange';
    export default {
        name: 'Dashboard',
        components:{
            CuentasPendientes,
            DateRangeField,
            GraficaCompras,
            GraficaDinero,
            GraficaProductos,
            GraficaVenta,
            InventarioResumen,
            PageHeader,
            StatCard,
            StatusChip
        },
        data() {
            return {
                // "Últimos 7 días" por defecto: el dinero se pide al backend por rango y sin fechas traeria todas las ventas,
                // y la semana reciente es lo que se revisa a diario (con 7 días las gráficas rotulan Lunes, Martes...).
                range: presetRange('last7'),
                tab: 0,
                // Filtros del tablero: vacíos = todas las sucursales / todos los productos.
                filters: { sucursalId: null, productoId: null },
                sucursales: [],
                productos: [],
                items: [
                    {
                        tone:        'info',
                        src:         `${this.$store.state.auth.rutaImg}pollo_blanco.png`,
                        title:       'Compras',
                        description: 'Nuevas mercancias',
                        actionLabel: 'Ir a compras',
                        icon:        'fas fa-shopping-cart',
                        to:          '/controlPanel/entradas'
                    },
                    {
                        tone:        'primary',
                        src:         `${this.$store.state.auth.rutaImg}procesado.png`,
                        title:       'Ventas',
                        description: 'Ventas de productos',
                        actionLabel: 'Ir a ventas',
                        icon:        'fas fa-cash-register',
                        to:          '/controlPanel/ventas'
                    },
                ],
            }
        },
        computed: {
            roles(){
                return this.$store.state.auth.user?.roles ?? [];
            },
            soloUsuario(){
                // `roles[0]` devolvia solo el primer rol del usuario: con
                // varios roles, el que no fuera ROLE_USER quedaba oculto.
                // Ahora se comprueba si ALGUN rol del usuario es ROLE_USER.
                return can(CAP.SOLO_USUARIO, this.roles);
            },
            verTodas(){
                // ADMIN y ADMINISTRATOR_PRECIO ven todas las sucursales y las vistas de empresa (compras, por
                // cobrar, por pagar). El resto ve solo su sucursal; el backend responde 403 a esas vistas.
                return can(CAP.DASHBOARD_TODAS_SUCURSALES_VER, this.roles);
            },
            verTopProductos(){
                return can(CAP.DASHBOARD_TOP_PRODUCTOS_VER, this.roles);
            },
            // Secciones del tablero según capacidad; Inventario lo ven todos.
            tabs(){
                const roles = this.roles;
                return [
                    { key: 'resumen', label: 'Resumen', show: can(CAP.DASHBOARD_RESUMEN_VER, roles) },
                    { key: 'ventas', label: 'Ventas y piezas', show: can(CAP.DASHBOARD_VENTAS_VER, roles) },
                    { key: 'cuentas', label: 'Compras y cuentas', show: can(CAP.DASHBOARD_CUENTAS_VER, roles) },
                    { key: 'inventario', label: 'Inventario', show: true }
                ].filter((t) => t.show);
            },
            showSucursalFilter(){
                // Solo quien ve todas las sucursales puede elegir una; el resto ya está limitado a la suya.
                return this.verTodas && this.sucursales.length > 1;
            },
            // Lo que reciben todos los widgets: cada uno decide cuáles respeta y rotula con chips los que no (FilterBadges).
            filterProps(){
                const name = (list, id) => {
                    const found = id ? list.find((item) => item.id === id) : null;
                    return found ? String(found.nombre) : '';
                };
                return {
                    sucursalId: this.filters.sucursalId,
                    productoId: this.filters.productoId,
                    sucursalNombre: name(this.sucursales, this.filters.sucursalId),
                    productoNombre: name(this.productos, this.filters.productoId),
                };
            },
        },
        created(){
            this.loadCatalogs();
        },
        methods: {
            // Los catálogos solo llenan los filtros: si fallan, el filtro no aparece y el tablero sigue completo.
            async loadCatalogs(){
                const list = (resp) => (resp && Array.isArray(resp.data) ? resp.data : []);
                if( this.verTodas ){
                    this.sucursales = await SucursalDataService.lstSucursal().then(list).catch(() => []);
                }
                const [goods, services] = await Promise.all([
                    ProductoDataService.findAll(false).then(list).catch(() => []),
                    ProductoDataService.findAll(true).then(list).catch(() => [])
                ]);
                this.productos = [...goods, ...services].sort((a, b) => String(a.nombre).localeCompare(String(b.nombre), 'es'));
            },
        },
    }
</script>
<style scoped>
.dashboard-range {
    min-width: 220px;
}
/* PageHeader no hace wrap en sus acciones: las envuelve este contenedor para que bajen de fila en pantallas angostas. */
.dashboard-tools {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;
}
.dashboard-filter {
    min-width: 180px;
    width: 200px;
}
@media (max-width: 599px) {
    .dashboard-tools {
        width: 100%;
    }
    .dashboard-range,
    .dashboard-filter {
        width: 100%;
    }
}
</style>
